import { Doc, GetDocFromReference } from '@/firebase-exports'

const i18nPathToKey = 'documentation.texts.automatedTasks.creation.'
const attributesAndMetadatas = {
  '{id}': 'li0',
  '{codigo_organismo_emisor}': 'li1',
  '{codigo_organismo_emisor_raiz}': 'li2',
  '{concepto}': 'li3',
  '{nif_peticion}': 'li4',
  '{nif_titular}': 'li5',
  '{nombre_organismo_emisor}': 'li6',
  '{nombre_organismo_emisor_raiz}': 'li7',
  '{nombre_titular}': 'li8',
  '{fecha_puesta_disposicion}': 'li9',
  '{identificador}': 'li9-2',
  '{fecha_aceptacion}': 'li9-3',
  //
  '{metadata.referencia}': 'li10',
  '{metadata.importeAPagar}': 'li11',
  '{metadata.totalAIngresar}': 'li12',
  '{metadata.codigoSeguroVerificacion}': 'li13',
  '{metadata.fechaVencimiento}': 'li14',
  '{metadata.baseSancion}': 'li15',
  '{metadata.sancionResultante}': 'li16',
  '{metadata.sancionReducida}': 'li17',
  '{metadata.importeInteres}': 'li18',
  '{metadata.modeloIntereses}': 'li19',
  '{metadata.ejercicio}': 'li20',
  '{metadata.periodo}': 'li21',
  '{metadata.importePendienteTotal}': 'li22',
  '{metadata.importeAEmbargar}': 'li23',
  '{metadata.importeEmbargado}': 'li24',
  '{metadata.entidadBancaria}': 'li25',
  '{metadata.numeroCuenta}': 'li26',
  '{metadata.cuotaBase}': 'li27',
  '{metadata.justificante}': 'li28',
  '{metadata.numeroDiligencia}': 'li29',
  '{metadata.fechaDiligencia}': 'li30',
  '{metadata.pagador}': 'li31',
  '{metadata.nifPagador}': 'li31-2',
  '{metadata.nombreObligadoPago}': 'li32',
  '{metadata.NIFObligadoPago}': 'li33',
  '{metadata.direccionObligadoPago}': 'li33-2',
  '{metadata.importeTotal}': 'li34',
  '{metadata.ssNombreObligadoPago}': 'li35',
  '{metadata.ssNifObligadoPago}': 'li36',
  '{metadata.ssReferencia}': 'li37',
  '{metadata.ssTipoIdentificador}': 'li38',
  '{metadata.ssRegimen}': 'li39',
  '{metadata.ssExpediente}': 'li40',
  '{metadata.ssNumeroDocumento}': 'li41',
  '{metadata.ssPagador}': 'li42',
  '{metadata.ssImporteTotal}': 'li43',
  '{metadata.ssObservaciones}': 'li44',
  '{metadata.ssCodigo}': 'li45',
  '{metadata.ssFecha}': 'li46',
  '{metadata.ssBancoAPagar}': 'li47',
  '{metadata.expdt}': 'li48',
  '{metadata.fechaDenuncia}': 'li49',
  '{metadata.matricula}': 'li50',
  '{metadata.fechaNotificacion}': 'li51',
  '{metadata.tipoNotificacion}': 'li52',
  '{metadata.identificador}': 'li53',
  '{metadata.expediente}': 'li54',
  // aeat, datos xml generico
  '{metadata.claveAplicacionXML}': 'li55',
  '{metadata.conceptoXML}': 'li56',
  '{metadata.oficinaRemitenteXML}': 'li57',
  '{metadata.tipoXML}': 'li58',
}

/**
 * Obtiene los nombres de los metadatos de un determinado tipo de notificacion
 * @param {String} tipo nombre del tipo de notificacion
 * @returns {Array} Lista de nombres de metadatos utilizados por el tipo
 */
export const getMetaKeysByTipo = (tipo) => {
  if (tipo === 'resLiqProv')
    return [
      'referencia',
      'importeAPagar',
      'totalAIngresar',
      'codigoSeguroVerificacion',
      'fechaVencimiento',
      'baseSancion',
      'sancionResultante',
      'sancionReducida',
      'importeInteres',
      'modeloIntereses',
      'ejercicio',
      'periodo',
      'importePendienteTotal',
      'importeAEmbargar',
      'importeEmbargado',
      'entidadBancaria',
      'numeroCuenta',
      'cuotaBase',
    ]
  else if (tipo === 'AcImSaInTri')
    return [
      'referencia',
      'codigoSeguroVerificacion',
      'ejercicio',
      'periodo',
      'fechaVencimiento',
      'modeloIntereses',
      'baseSancion',
      'sancionResultante',
      'sancionReducida',
    ]
  else if (tipo === 'LiInDeDeEx')
    return [
      'referencia',
      'codigoSeguroVerificacion',
      'ejercicio',
      'periodo',
      'fechaVencimiento',
      'importeInteres',
      'modeloIntereses',
      'ejercicio',
      'periodo',
      'justificante',
      'cuotaBase',
    ]
  else if (tipo === 'DiEmCuBa')
    return [
      'referencia',
      'codigoSeguroVerificacion',
      'ejercicio',
      'periodo',
      'fechaVencimiento',
      'importePendienteTotal',
      'importeAEmbargar',
      'importeEmbargado',
      'entidadBancaria',
      'numeroCuenta',
    ]
  else if (tipo === 'DiEmCred')
    return [
      'codigoSeguroVerificacion',
      'referencia',
      'numeroDiligencia',
      'fechaDiligencia',
      //'nombreObligadoPago',
      'direccionObligadoPago',
      'NIFObligadoPago',
      //'nombrePagador',
      //'nifPagador',
      'importeTotal',
    ]
  else if (tipo === 'AEAT_RE02')
    return [
      'codigoSeguroVerificacion',
      'referencia',
      'numeroDiligencia',
      'fechaDiligencia',
      'nombreObligadoPago',
      'direccionObligadoPago',
      'NIFObligadoPago',
      'nombrePagador',
      'nifPagador',
      'importeTotal',
    ]
  else if (tipo === 'embargoSS')
    return [
      'ssNombreObligadoPago',
      'ssNifObligadoPago',
      'ssReferencia',
      'ssTipoIdentificador',
      'ssRegimen',
      'ssExpediente',
      'ssNumeroDocumento',
      'ssPagador',
      'ssImporteTotal',
      'ssObservaciones',
      'ssCodigo',
      'ssFecha',
      'ssBancoAPagar',
    ]
  else if (tipo === 'multasDGT')
    return [
      'expdt',
      'fechaDenuncia',
      'matricula',
      'fechaNotificacion',
      'tipoNotificacion',
      'identificador',
    ]
  else if (tipo === 'aeat')
    return [
      'claveAplicacionXML',
      'conceptoXML',
      'oficinaRemitenteXML',
      'tipoXML',
    ]
  else if (tipo === 'embargoCreditoSS') return ['expediente']
  else if (tipo === 'embargoNominaSS') return ['expediente']
  else if (tipo === 'restoProcedimientosSS') return ['expediente']
  else return []
}

export async function procesarData(data, isGenericFilterAEAT = false) {
  const resultado = {}

  if (Array.isArray(data)) {
    for (const path of data) {
      // solo procesar los paths que empiecen por "users/", que son los filtros personalizados,
      // los filtros genericos no tienen un atributo types[].
      if (
        (typeof path === 'string' &&
          path.startsWith('users/') &&
          path.includes('/filters/')) ||
        isGenericFilterAEAT
      ) {
        const filterDoc = await getDocFromPath(path)
        if (filterDoc !== null) {
          // en types[] puede venir mas de un tipo de documento, si es que existe el atributo
          if (filterDoc.types) {
            for (const tipo of filterDoc.types) {
              // por cada tipo obtenemos los nombres de sus metadatos asociados
              const metakeys = getMetaKeysByTipo(tipo)

              // transforma algo como [ "expdt", "matricula", "identificador" ]
              // en [ "{metadata.expdt}", "{metadata.matricula}", "{metadata.identificador}" ]
              const outputkeys = metakeys.map((attr) => `{metadata.${attr}}`)

              // Guardamos en el objeto resultado
              resultado[tipo] = outputkeys
            }
          } else {
            // Caso especial: AEAT es un filtro generico, pero se requiere poder utilizar sus atributos del XML
            if (filterDoc.name.toLowerCase() === 'aeat') {
              const metakeys = getMetaKeysByTipo('aeat')

              // transforma algo como [ "conceptoXML", "claveAplicacionXML", "oficinaRemitenteXML", "tipoXML" ]
              // en [ "{metadata.conceptoXML}", "{metadata.claveAplicacionXML}", ..." ]
              const outputkeys = metakeys.map((attr) => `{metadata.${attr}}`)

              // Guardamos en el objeto resultado
              resultado['aeat'] = outputkeys
            }
          }
        }
      }
    }
  } else if (typeof data === 'string') {
    // en data viene un nombre de tipo de notificacion, p.e. 'multasDGT'
    // obtenemos los nombres de sus metadatos asociados
    const metakeys = getMetaKeysByTipo(data)

    // transforma algo como [ "expdt", "matricula", "identificador" ]
    // en [ "{metadata.expdt}", "{metadata.matricula}", "{metadata.identificador}" ]
    const outputkeys = metakeys.map((attr) => `{metadata.${attr}}`)

    // Guardamos en el objeto resultado
    resultado[data] = outputkeys
  }
  // Caso 3: cualquier otro tipo
  else {
    //console.log('Tipo de data no soportado:', typeof data)
  }

  return resultado
}

/**
 * Obtiene la clave i18n de un atributo de la notificacion o de un metadato de un determinado tipo de notificacion.
 * @param {String} attr atributo o metadato a buscar. Puede ser en formato 'marca' como '{id}' o como nombre: 'id'.
 * @returns {String} clave i18n o vacio si no lo encuentra.
 */
export const getAttributeOrMetadataDescription = (attr) => {
  if (typeof attr !== 'string' || !attr) return ''

  if (!(attr.startsWith('{') && attr.endsWith('}'))) {
    attr = `{${attr}}`
  }

  if (attributesAndMetadatas[attr]) {
    return i18nPathToKey + attributesAndMetadatas[attr]
  }
  return ''
}

//async function getDocFromPath(path) {
export async function getDocFromPath(path) {
  try {
    const docRef = Doc(path) // string con el path al documento, devuelve la referencia al documento.
    const doc = await GetDocFromReference(docRef) // lee el documento a partir de su referencia.
    return doc
  } catch (err) {
    console.error('Error leyendo documento:', path, err)
    return null
  }
}
